// Sugestões no carrinho lateral do BALCÃO, logo acima do Total (pedido do dono,
// 29/09/2026: "as sugestões, se ativas, podem ficar na parte de baixo do
// carrinho, com fotos menores, de maneira discreta"). São as da campanha
// Sugestões Inteligentes (as mesmas da sacola do cardápio digital): com a
// campanha desligada em Campanhas o servidor devolve nada e o bloco some.
// Até 3; tocar adiciona como um clique no produto (etapas abrem a montagem).
import { ImageOff, Plus } from "lucide-react";
import { useMemo } from "react";

import { useSugestoes } from "../../sugestoes";
import { fmt, getImageUrl } from "../lib/helpers";

export default function SugestoesLateral({ ctx }) {
  const { cart, products, addSuggestionToCart } = ctx;
  const produtosPorId = useMemo(() => new Map((products || []).map((p) => [String(p.id), p])), [products]);
  const carrinhoIds = useMemo(() => [...new Set(cart.map((i) => String(i.id)))], [cart]);
  const lista = useSugestoes({ ativo: cart.length > 0, lugar: "sacola", carrinhoIds, produtosPorId });
  if (!lista.length) return null;
  return (
    <div className="shrink-0 px-3 pt-2 pb-1 border-t border-zinc-800" data-e2e="sugestoes-lateral">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-zinc-500 mb-1.5">Que tal adicionar?</p>
      <div className="grid grid-cols-3 gap-2">
        {lista.slice(0, 3).map(({ produto: p }) => (
          <button key={p.id} type="button" onClick={() => addSuggestionToCart(p)} title={p.name} data-e2e="sugestao-lateral"
            className="text-left rounded-lg bg-zinc-800/50 hover:bg-zinc-800 border border-zinc-800 hover:border-orange-500/40 overflow-hidden transition-colors active:scale-95">
            <div className="h-12 bg-zinc-800">
              {p.photo_url
                ? <img src={getImageUrl(p.photo_url)} alt="" className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} />
                : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-4 h-4 text-zinc-600" /></div>}
            </div>
            <div className="px-1.5 py-1">
              <p className="text-[10px] text-zinc-300 leading-tight truncate">{p.name}</p>
              <p className="text-[10px] font-semibold text-orange-500 flex items-center justify-between">R$ {fmt(p.sale_price)}<Plus className="w-3 h-3" /></p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
